import { MAP_TYPES } from '@deck.gl/carto';

const HISTORICALHIGHCOLLISION_SOURCE_ID = 'historicalHighCollisionSource';

const source = {
  id: HISTORICALHIGHCOLLISION_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  // data: 'historical_high_collision_source',
};

export default source;
